(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["discount-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const dialog = document.getElementById('cs-discount-popup');
      if (!dialog || typeof dialog.showModal !== 'function' || window.Shopify?.designMode) return;
      const key = dialog.dataset.storageKey;
      const day = 24 * 60 * 60 * 1000;
      try {
        const lastShown = Number(window.localStorage.getItem(key));
        if (lastShown && Date.now() - lastShown < 7 * day) return;
      } catch (_) {}
      let opened = false;
      const open = () => {
        if (opened || dialog.open) return;
        opened = true;
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('mouseout', onExit);
        dialog.showModal();
        try { window.localStorage.setItem(key, String(Date.now())); } catch (_) {}
      };
      const onScroll = () => { if (window.scrollY >= window.innerHeight * 1.25) open(); };
      const onExit = (event) => { if (event.clientY <= 0 && !event.relatedTarget) open(); };
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('mouseout', onExit);
      dialog.querySelector('[data-cs-discount-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
